import { Chain, isChainIndexed } from "@nitro-ape/shared/models/enums/chain";
import { Pool, PoolSchema } from "@nitro-ape/shared/models/pool";
import {  QueryKey, queryOptions } from "@tanstack/react-query";
import { isServer } from "../../../platform/is-server/is-server";
import { makeServerApiRequest } from "../../../platform/server-api/server-api";
import api from "../../../platform/api/api";

export const getPool = async ({
  poolId,
  chain,
}: {
  poolId: string | null;
  chain: Chain;
}): Promise<Pool | null> => {
  if (!poolId) return null;
  if (!isChainIndexed(chain)) {
    return null;
  }

  if (isServer) {
    try {
      const { data } = await makeServerApiRequest<Pool>(
        `/pools/${poolId}?chain=${chain}`,
      );
      return PoolSchema.parse(data);
    } catch (error) {
      console.log("Server-side pool fetch error:", error);
      return null;
    }
  }

  const { data } = await api.get<Pool>(`/pools/${poolId}?chain=${chain}`);
  try {
    return PoolSchema.parse(data);
  } catch (error) {
    console.log(error);
    return null;
  }
};
export const getPoolQueryKey = (
  chain: Chain,
  poolId: string | null,
): QueryKey => {
  return ["pool", chain, poolId];
};

export const getPoolQueryOptions = (chain: Chain, poolId: string | null) => {
  return queryOptions({
    queryKey: getPoolQueryKey(chain, poolId),
    queryFn: () => getPool({ chain, poolId }),
    refetchInterval(query) {
      if (query.state.data?.is_migrating) {
        return 1000 * 3;
      }
      return false;
    },

    enabled: !!poolId,
  });
};
